// extracted by mini-css-extract-plugin
export var orderSummary = "styles_orderSummary__jM61o";
export var row = "styles_row__p62k9";